import { gql } from "@apollo/client";

export const DEFLEET_VEHICLE = gql`
  mutation deFleetVehicle($vehicleDefleetInput: VehicleDefleetInput) {
    deFleetVehicle(vehicleDefleetInput: $vehicleDefleetInput) {
      success
      message
    }
  }
`;